import Vue from "vue";
import stroe from "@/store/index";
import useLocalStorage from "../useLocalStorage";
import { needStartTrialList } from "@/router/index";
function useTrial() {
  const show = Vue.observable({ value: false });
  const isTiming = Vue.observable({ value: false });
  const EXPERIENCE_TIME = 30;
  const { value: eTime } = useLocalStorage("experienceTime", EXPERIENCE_TIME);
  let timer;
  function checkVip() {
    if (stroe.state && stroe.state.isVip) {
      stop();
      changeTrialDialog(false);
      return true;
    }
    return false;
  }
  function start(option = {}) {
    if (checkVip()) return;
    const minTime = option.minTime;
    const curPath = option.path;
    // 如果有最小值，设置最小值
    if (minTime && (minTime > eTime.value || eTime.value === EXPERIENCE_TIME)) {
      eTime.value = minTime;
    }
    // 如果当前路径不在需要计时列表中，则不打开计时
    if (
      curPath &&
      needStartTrialList.findIndex((item) => curPath.includes(item)) === -1
    ) {
      return;
    }
    console.log("开始计时", eTime);
    stop();
    timer = setInterval(() => {
      isTiming.value = true;
      eTime.value = eTime.value - 1;
      console.log("剩余", eTime.value);
      if (eTime.value === 0) {
        if (checkVip()) return;
        stop();
        changeTrialDialog(true);
        eTime.value = EXPERIENCE_TIME;
      }
    }, 1000);
  }
  function stop() {
    if (timer) {
      isTiming.value = false;
      clearInterval(timer);
    }
  }
  function changeTrialDialog(type) {
    if (stroe.state && stroe.state.isVip) {
      show.value = false;
    } else {
      show.value = type;
    }
  }

  return {
    startTrialTimer: start,
    stopTrialTimer: stop,
    showTrial: show,
    changeTrialDialog,
    isTiming,
  };
}
export default useTrial;
